// @ts-nocheck

import React from 'react';
import { Box, PageHeader, Text } from '@primer/react';
import { MailIcon, LogoGithubIcon, SunIcon, MoonIcon } from '@primer/octicons-react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { FluentProvider, Button, webLightTheme, webDarkTheme } from "@fluentui/react-components";

import {
    MessageBar,
    MessageBarActions,
    MessageBarTitle,
    MessageBarBody,
    Link,
} from "@fluentui/react-components";

interface HeadProps {
    toggleTheme: () => void;
    isDarkMode: boolean;
}

i18n.on('initialized', () => {
    if (navigator.language.includes('zh')) {
        i18n.changeLanguage('zh');
        document.documentElement.lang = 'zh-Hans';
    }
});

const Head: React.FC<HeadProps> = ({ toggleTheme, isDarkMode }) => {
    const { t } = useTranslation();

    const MSDCMsgBar = () => {
        return (
            <Box sx={{ p: 3, }}>
                <MessageBar layout='multiline' intent='success'>
                    <MessageBarBody>
                        {/* @ts-ignore */}
                        <MessageBarTitle>{t('header_msdc_title')}</MessageBarTitle>
                        {/* @ts-ignore */}
                        <Link href='https://msdc.licaoz.com/?source=store_parser' target='_blank'>{t('header_msdc_name')}</Link>{" "}{t('header_msdc_desc')}
                    </MessageBarBody>
                </MessageBar>
            </Box>
        );
    };

    return (
        <header>
            <FluentProvider theme={isDarkMode ? webDarkTheme : webLightTheme}>
                <Box
                    sx={{
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderColor: 'border.default',
                        p: 3,
                        backgroundColor: 'background.primary',
                    }}
                >
                    <PageHeader role="banner">
                        <PageHeader.TitleArea>
                            {/* @ts-ignore */}
                            <PageHeader.Title> {t('str_heading')} </PageHeader.Title>
                        </PageHeader.TitleArea>

                        <PageHeader.ContextArea className='header-ctx'>
                            <Button onClick={toggleTheme} icon={isDarkMode ? <SunIcon /> : <MoonIcon />}>
                                {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                            </Button>
                            <Button onClick={
                                () => {
                                    const currentLang = i18n.language;
                                    i18n.changeLanguage(currentLang === 'en' ? 'zh' : 'en');
                                }
                            }>
                                {/* @ts-ignore */}
                                {i18n.language === 'en' ? '中文' : 'English'}
                            </Button>
                        </PageHeader.ContextArea>
                        <PageHeader.Actions className='header-actions'>
                            <Button onClick={toggleTheme} icon={isDarkMode ? <SunIcon /> : <MoonIcon />} />
                            <Button onClick={
                                () => {
                                    const currentLang = i18n.language;
                                    i18n.changeLanguage(currentLang === 'en' ? 'zh' : 'en');
                                }
                            }>
                                {/* @ts-ignore */}
                                {i18n.language === 'en' ? '中文' : 'English'}
                            </Button>
                        </PageHeader.Actions>
                    </PageHeader>
                </Box>
                {navigator.languages.some(lang => lang.startsWith('zh')) ? <MSDCMsgBar /> : null}
            </FluentProvider>
        </header>
    );
};

export default Head;
